import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import { resumeRmlOverlayModal, suspendRmlOverlayModal } from "../../utils/rmlModalStack.js";
import { MediaLibrarySelector } from "../media/mediaLibrarySelector.js";
const CoverImageSelector = ({ input, mountElement })=>{
    const [attachmentId, setAttachmentId] = useState(()=>{
        const value = Number(input.val());
        return value > 0 ? value : undefined;
    });
    useEffect(()=>{
        input.val(attachmentId);
    }, [
        attachmentId,
        input
    ]);
    const suspendMetaBox = useCallback(()=>{
        suspendRmlOverlayModal(mountElement);
    }, [
        mountElement
    ]);
    const resumeMetaBox = useCallback(()=>{
        resumeRmlOverlayModal(mountElement);
    }, [
        mountElement
    ]);
    return /*#__PURE__*/ _jsx(MediaLibrarySelector, {
        attachmentId: attachmentId,
        onChange: (nextId)=>setAttachmentId(nextId),
        onClose: resumeMetaBox,
        title: "Select cover image",
        allowedTypes: [
            "image"
        ],
        render: ({ open, reset, attachmentId: currentAttachmentId, url })=>{
            const handleOpen = ()=>{
                suspendMetaBox();
                open();
            };
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs("p", {
                        style: {
                            marginTop: 0
                        },
                        children: [
                            /*#__PURE__*/ _jsx("a", {
                                className: "button",
                                onClick: handleOpen,
                                children: currentAttachmentId ? "Replace image" : "Select from media library"
                            }),
                            "\xa0",
                            currentAttachmentId && /*#__PURE__*/ _jsx("a", {
                                className: "button",
                                onClick: reset,
                                children: "Remove image"
                            })
                        ]
                    }),
                    url && /*#__PURE__*/ _jsx("img", {
                        style: {
                            maxWidth: "100%",
                            height: "auto"
                        },
                        src: url
                    })
                ]
            });
        }
    });
};
export { CoverImageSelector };
